import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Modal from '@cx/couturier/labs/Modal'
import { updateSubmitDisabled, userDeactivated, generateTicketId } from '../../store/actions.js'

export const WelcomeBackModal = ({ deactivatedModal, dispatchUserDeactivated, dispatchGenerateTicketId, dispatchUpdateSubmitDisabled }) => {
  const handleRedirect = async () => {
    const { ticketID } = await dispatchGenerateTicketId()
    window.location.href = `/auth/welcome-back?ticketId=${ticketID}`
  }

  return (
    <Modal
      confirmText='Get Started'
      contentLabel='Welcome Back modal'
      description='Welcome Back'
      isOpen={deactivatedModal}
      name='deactivated-user'
      onClose={() => {
        dispatchUserDeactivated()
        dispatchUpdateSubmitDisabled(false)
      }}
      onConfirm={handleRedirect}
      onRequestClose={() => {}}
      size='medium'
      titleText='Welcome'
    >
      <p>
        We need to verify your identity and setup your security profile to ensure your information remains secure. This process should only take a few
        minutes.
      </p>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  deactivatedModal: state.submit.deactivatedModal
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      dispatchUserDeactivated: userDeactivated,
      dispatchUpdateSubmitDisabled: updateSubmitDisabled,
      dispatchGenerateTicketId: generateTicketId
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeBackModal)
